export const ADD_ACTIVE_ARTICLE_ACTIVITY = 'ADD_ACTIVE_ARTICLE_ACTIVITY';
export const CLEAR_READ_PAGE_MODE = 'CLEAR_READ_PAGE_MODE';
export const SET_READ_PAGE_ELEMENTS = 'SET_READ_PAGE_ELEMENTS';
export const SET_READ_PAGE_MODE = 'SET_READ_PAGE_MODE';
export const SET_READ_PAGE_CONTEXT = 'SET_READ_PAGE_CONTEXT';
export const SET_REVEAL_ANSWER = 'REVEAL_ANSWER';
export const UPDATE_ACTIVE_ARTICLE_QUIZ = 'UPDATE_ACTIVE_ARTICLE_QUIZ';
